import { matchers as sessionMatchers } from '../session';
import * as selectors from '../selectors';
import { STATES } from '../../constants';

export function AppShellEpic(appShell) {
  'ngInject';

  return (action, { getState }) => {
    // Item was updated.
    if (
      action.type === 'upd/REQUEST_RESULT' &&
      (action.meta.request.payload.url.includes('/v2/items') ||
        action.meta.request.payload.url.includes('/v2/users'))
    ) {
      appShell.interactors.session.actions.fetchSession();
      return;
    }

    // Handle updating the currrent step for the daisyChain
    if (
      sessionMatchers.isReadSuccess(action) ||
      action.type === '@@reduxUiRouter/$stateChangeSuccess'
    ) {
      // Set the current step
      const kind = selectors.router.currentDataMoveItemType(getState());
      appShell.interactors.daisyChain.actions.setCurrent(kind);
      // set the router equal to current location
      setTimeout(() => {
        appShell.interactors.router.setCurrentPathAndDontFireCallbacks(
          window.location.href.replace(window.location.origin, '')
        );
      });
    }
    // Handle clearing terminal route status
    if (action.type === '@@reduxUiRouter/$stateChangeSuccess') {
      // Set the current step
      appShell.interactors.daisyChain.actions.isTerminalRoute(false);
    }

    // Handle Sign In route navigation (Stop Gap)
    if (
      action.type === '@@reduxUiRouter/$stateChangeStart' &&
      action.payload.toState.name === STATES.SIGN_IN
    ) {
      appShell.interactors.router.go('/sign-in');
    }
  };
}
